import clsx from 'clsx';
import {
  forwardRef, useRef, useEffect,
} from 'react';
import '../scss/TextInput.scss';

const TextInput = forwardRef(({
  type = 'text',
  className,
  id,
  name,
  value,
  width,
  border,
  onChange,
  onFocus,
  onBlur,
  error,
  iconPrefix = null,
  iconSuffix = null,
  maxLength,
  readOnly,
  placeholder,
  onClick,
  onKeyDown,
  autoComplete,
  backgroundColor,
  fontWeight,
  height,
  fontSize,
  link = null,
  isErrorTrigger = true,
  isDisabled,
}, ref) => {
  const $container = useRef();
  const $input = useRef();
  const iconRef = useRef(null);
  const linkRef = useRef(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if ($input.current && iconRef.current) {
        $input.current.style.paddingLeft = `${iconRef.current.offsetWidth}px`;
      }
    }, 30);

    return () => clearTimeout(timeoutId);
  }, [value]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if ($input.current && linkRef.current) {
        $input.current.style.paddingLeft = `${linkRef.current.offsetWidth}px`;
      }
    }, 30);

    return () => clearTimeout(timeoutId);
  }, [value]);

  function handleMouseDown(event) {
    if ($input.current.contains(event.target)) {
      return;
    }
    if ($container.current.contains(event.target)) {
      event.preventDefault();
      $input.current.focus();
    }
  }

  function handleFocus(event) {
    $container.current.classList.add('ui-textinput__focused');
    if (onFocus) {
      onFocus(event);
    }
  }

  function handleBlur(event) {
    $container.current.classList.remove('ui-textinput__focused');
    if (onBlur) {
      onBlur(event);
    }
  }

  return (
    <div
      ref={$container}
      onMouseDown={handleMouseDown}
      className={clsx('ui-textinput', className, {
        'ui-textinput--invalid': !!error,
      })}
      style={{ width }}
    >
      <div className="ui-textinput__input-wrapper">
        {iconPrefix && (
          <div
            id="icon-prefix"
            className="ui-textinput__icon-prefix"
            ref={iconRef}
          >
            {iconPrefix}
          </div>
        )}
        {link && (
          <div
          id="link-prefix"
            className="ui-textinput__link-prefix"
            ref={linkRef}
          >
            {link}
          </div>
        )}
        <input
          id={id}
          name={name}
          style={{
            color: readOnly && '#777',
            backgroundColor,
            fontWeight,
            height,
            border,
            fontSize,
          }}
          className="ui-textinput__input"
          ref={(element) => {
            $input.current = element;
            if (ref) {
              ref.current = element;
            }
          }}
          type={type}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={isDisabled}
          onClick={onClick}
          onKeyDown={onKeyDown}
          onWheel={(event) => event.target.blur()}
          autoComplete={autoComplete}
        />
        {iconSuffix && <div className="ui-textinput__icon-suffix">{iconSuffix}</div>}
      </div>
      {error && isErrorTrigger && <div className="ui-textinput__error">{error}</div>}
      {!isErrorTrigger && <div className="ui-textinput__error" style={{ color: !error && 'transparent' }}>{error || ''}</div>}
    </div>
  );
});

export default TextInput;
